import { render, staticRenderFns } from "./navigation-drawer.vue?vue&type=template&id=895e0882&scoped=true&"
import script from "./navigation-drawer.component.ts?vue&type=script&lang=js&"
export * from "./navigation-drawer.component.ts?vue&type=script&lang=js&"
import style0 from "./navigation-drawer.vue?vue&type=style&index=0&id=895e0882&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895e0882",
  null
  
)

export default component.exports